import { action, makeObservable, observable } from 'mobx';

export interface IParsedFiles {
    createdRules: IRule[];
    updatedRules: IRule[];
    invalidRules: IRule[];
}

export interface IParsedFilesError {
    error?: {
        name: string;
        message: string;
    };
}

export interface IRule {
    id?: string;
    isSelected?: boolean;
    name: string;
    short: string;
    sourceId?: string;
    description: string;
    body?: string;
    sourceVersion?: string;
    severity: string | number;
    mitreId: string;
    mitreTactic: string;
    type: string;
    action: string[];
    author?: string;
    createdOn?: string;
    message?: string;
    data?: {
        actions?: {
            alert?: boolean;
        };
    };
    actions?: {
        alert?: boolean;
    };
    active?: boolean;
}

export default class RuleStore {
    rule: IRule = {
        name: '',
        short: '',
        description: '',
        severity: '',
        mitreId: '',
        mitreTactic: '',
        type: '',
        action: []
    };

    constructor(rule: IRule & { author?: { email: string } }) {
        this.update(rule);

        makeObservable(this, {
            rule: observable,
            update: action
        });
    }

    update(rule: IRule & { author?: { email: string } }): void {
        this.rule = {
            ...this.rule,
            ...rule,
            author: rule.author?.email ? rule.author.email : 'Infocyte'
        };
    }
}
